export default () => ({
  directoryWrapper: {
    marginTop: 32
  }
});
